export default __webpack_public_path__ + "static/media/eb-ultra-pro-banner-3.cf063fe9.jpg";